"use client";

import React from "react"

import {
  BarChart2Icon,
  ChartAreaIcon,
  IndianRupeeIcon,
  TrendingUp,
} from "lucide-react";
import {
  Area,
  AreaChart,
  Bar,
  BarChart,
  CartesianGrid,
  Cell,
  Line,
  LineChart,
  XAxis,
  YAxis,
} from "recharts";

import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "../../components/ui/card";
import {
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
} from "../../components/ui/chart";

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../components/ui/select";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../components/ui/table";
import { useEffect, useState } from "react";
import { Button } from "../../components/ui/button";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../../components/ui/tabs";
import CummPnlTradingViewChart from "./CummPnlTradingViewChart";

export const description = "An area chart with gradient fill";

const chartData = [
  { date: "01-07-2024", pnl: 45890 },
  { date: "02-07-2024", pnl: 9800 },
  { date: "03-07-2024", pnl: 30000 },
  { date: "04-07-2024", pnl: -12000 },
  { date: "05-07-2024", pnl: 27000 },
  { date: "06-07-2024", pnl: -20000 },
  { date: "07-07-2024", pnl: 49000 },
  { date: "08-07-2024", pnl: 20000 },
  { date: "09-07-2024", pnl: 40000 },
  { date: "10-07-2024", pnl: -25000 },
  { date: "11-07-2024", pnl: -25000 },
  { date: "12-07-2024", pnl: 83000 },
  { date: "13-07-2024", pnl: -50000 },
  { date: "14-07-2024", pnl: 90000 },
  { date: "15-07-2024", pnl: 15000 },
  { date: "16-07-2024", pnl: -45000 },
  { date: "17-07-2024", pnl: 60000 },
  { date: "18-07-2024", pnl: 25000 },
  { date: "19-07-2024", pnl: -15000 },
  { date: "20-07-2024", pnl: 78000 },
  { date: "21-07-2024", pnl: 32000 },
  { date: "22-07-2024", pnl: -10000 },
  { date: "23-07-2024", pnl: 20000 },
  { date: "24-07-2024", pnl: 40000 },
  { date: "25-07-2024", pnl: 25000 },
  { date: "26-07-2024", pnl: 12000 },
  { date: "27-07-2024", pnl: 30000 },
  { date: "28-07-2024", pnl: -35000 },
  { date: "29-07-2024", pnl: 100000 },
  { date: "30-07-2024", pnl: 50000 },
  { date: "31-07-2024", pnl: 35000 },
  { date: "01-08-2024", pnl: 25000 },
  { date: "02-08-2024", pnl: 20000 },
  { date: "03-08-2024", pnl: -5000 },
  { date: "04-08-2024", pnl: -20000 },
  { date: "05-08-2024", pnl: 15000 },
  { date: "06-08-2024", pnl: 50000 },
  { date: "07-08-2024", pnl: -18000 },
  { date: "08-08-2024", pnl: 30000 },
  { date: "09-08-2024", pnl: 10000 },
  { date: "10-08-2024", pnl: -40000 },
  { date: "11-08-2024", pnl: 75000 },
  { date: "12-08-2024", pnl: -35000 },
  { date: "13-08-2024", pnl: 50000 },
  { date: "14-08-2024", pnl: 60000 },
  { date: "15-08-2024", pnl: -25000 },
  { date: "16-08-2024", pnl: 90000 },
  { date: "17-08-2024", pnl: 30000 },
  { date: "18-08-2024", pnl: -50000 },
  { date: "19-08-2024", pnl: 60000 },
  { date: "20-08-2024", pnl: 20000 },
  { date: "21-08-2024", pnl: -15000 },
  { date: "22-08-2024", pnl: 32000 },
  { date: "23-08-2024", pnl: 10000 },
  { date: "24-08-2024", pnl: 45000 },
  { date: "25-08-2024", pnl: -20000 },
  { date: "26-08-2024", pnl: 70000 },
  { date: "27-08-2024", pnl: 15000 },
  { date: "28-08-2024", pnl: -10000 },
  { date: "29-08-2024", pnl: 30000 },
  { date: "30-08-2024", pnl: -35000 },
  { date: "31-08-2024", pnl: 45000 },
  { date: "01-09-2024", pnl: 80000 },
  { date: "02-09-2024", pnl: -5000 },
  { date: "03-09-2024", pnl: 32000 },
  { date: "04-09-2024", pnl: -40000 },
  { date: "05-09-2024", pnl: 20000 },
  { date: "06-09-2024", pnl: 15000 },
  { date: "07-09-2024", pnl: -18000 },
  { date: "08-09-2024", pnl: 45000 },
  { date: "09-09-2024", pnl: 25000 },
  { date: "10-09-2024", pnl: 50000 },
  { date: "11-09-2024", pnl: 30000 },
  { date: "12-09-2024", pnl: -15000 },
  { date: "13-09-2024", pnl: 12000 },
  { date: "14-09-2024", pnl: 32000 },
  { date: "15-09-2024", pnl: -25000 },
  { date: "16-09-2024", pnl: 60000 },
  { date: "17-09-2024", pnl: 75000 },
  { date: "18-09-2024", pnl: -45000 },
  { date: "19-09-2024", pnl: 50000 },
  { date: "20-09-2024", pnl: 10000 },
  { date: "21-09-2024", pnl: -20000 },
  { date: "22-09-2024", pnl: 40000 },
  { date: "23-09-2024", pnl: 25000 },
  { date: "24-09-2024", pnl: -35000 },
  { date: "25-09-2024", pnl: 75000 },
  { date: "26-09-2024", pnl: 20000 },
  //   { date: "27-09-2024", pnl: -15000 },
  //   { date: "28-09-2024", pnl: 50000 },
  //   { date: "29-09-2024", pnl: 30000 },
  //   { date: "30-09-2024", pnl: -5000 },
];

const chartConfig = {
  pnl: {
    label: "Daily PNL",
    color: "hsl(var(--chart-1))",
  },
};

// Helper for Indian number formatting (lakh/crore)
function formatIndianNumber(num) {
  if (num === undefined || num === null) return '';
  num = Number(num);
  if (Math.abs(num) >= 1e7) return (num / 1e7).toFixed(2) + ' Cr';
  if (Math.abs(num) >= 1e5) return (num / 1e5).toFixed(2) + ' L';
  return num.toLocaleString('en-IN');
}

export function DailyPNLChart({ dailyPnlMerged, assetDailyPnl, isWeekly, dailyPnlView, setDailyPnlView }) {
  const [selectedTab, setSelectedTab] = useState("All");
  const [viewChart, setViewChart] = useState("bar-chart");
  const [timeRange, setTimeRange] = useState("all");
  const [filteredData, setFilteredData] = useState([]);
  const assetKeys = ["All", "Nifty", "Bank", "Stock"];
  const assetColors = {
    Nifty: "#1f77b4",
    Bank: "#ff7f0e",
    Stock: "#2ca02c",
  };
  const getAssetData = (asset) => assetDailyPnl[asset] || [];
  const getCombinedData = () => dailyPnlMerged || [];
  // Helper for weekly label
  const getWeeklyLabel = (row) => {
    if (!row.week_start || !row.week_end) return row.week_start || row.date;
    return `${row.week_start} - ${row.week_end}`;
  };
  // Filtering logic for time range
  function filterByTimeRange(data) {
    if (timeRange === "all") return data;
    const now = new Date();
    return data.filter((d) => {
      const dateStr = isWeekly ? d.week_end : d.date;
      const [day, month, year] = dateStr.split("-");
      const date = new Date(`${year}-${month}-${day}`);
      let days = 0;
      if (timeRange === "7d") days = 7;
      else if (timeRange === "15d") days = 15;
      else if (timeRange === "30d") days = 30;
      return now - date < days * 24 * 60 * 60 * 1000;
    });
  }
  useEffect(() => {
    let data = selectedTab === "All" ? getCombinedData() : getAssetData(selectedTab);
    setFilteredData(filterByTimeRange(data));
  }, [selectedTab, dailyPnlMerged, assetDailyPnl, timeRange, isWeekly]);

  const CustomTooltipContent = ({ active, payload, label }) => {
    if (!active || !payload || !payload.length) return null;

    return (
      <div className="bg-black border border-gray-700 rounded p-3 shadow-lg">
        <p className="text-gray-300 mb-2">
          {label ? (() => {
            if (!isWeekly) {
              const [day, month, year] = label.split("-");
              const dateObj = new Date(`${year}-${month}-${day}`);
              return dateObj.toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric"
              });
            } else {
              return label;
            }
          })() : ""}
        </p>
        <div className="space-y-1">
          {payload.map((entry, index) => (
            <div key={index} className="flex items-center gap-2">
              <span
                className="w-3 h-3 rounded-full"
                style={{ backgroundColor: assetColors[entry.name] || entry.fill }}
              />
              <span className="text-gray-300">{entry.name}:</span>
              <span className="text-white font-medium">
                {formatIndianNumber(entry.value)}
              </span>
            </div>
          ))}
        </div>
      </div>
    );
  };

  return (
    <Card>
      <CardHeader>
        <div className="flex items-center justify-between">
          <div>
            <CardTitle>Daily PNL Chart</CardTitle>
            <CardDescription>
              {selectedTab === "All"
                ? `Comparison of Daily PNL for Nifty, Bank, and Stock (${isWeekly ? "Weekly" : "Daily"})`
                : `Showing Daily PNL for the last ${filteredData?.length} ${isWeekly ? "weeks" : "days"}`}
            </CardDescription>
          </div>
          <div className="flex flex-row items-center gap-4 ml-4">
            <Tabs value={selectedTab} onValueChange={setSelectedTab}>
              <TabsList>
                {assetKeys.map((asset) => (
                  <TabsTrigger key={asset} value={asset}>{asset}</TabsTrigger>
                ))}
              </TabsList>
            </Tabs>
            {/* Time range dropdown */}
            <select
              value={timeRange}
              onChange={e => setTimeRange(e.target.value)}
              className="bg-black text-white border border-gray-700 rounded px-2 py-1"
            >
              <option value="all">ALL</option>
              <option value="7d">7 days</option>
              <option value="15d">15 days</option>
              <option value="30d">30 days</option>
            </select>
            <span className="font-semibold text-white/80">View:</span>
            <select
              value={dailyPnlView}
              onChange={e => setDailyPnlView(e.target.value)}
              className="bg-black text-white border border-gray-700 rounded px-2 py-1"
            >
              <option value="daily">Daily</option>
              <option value="weekly">Weekly</option>
            </select>
            {/* Chart type toggle */}
            <div className="flex items-center justify-between space-x-2 px-2 rounded-[6px] bg-muted py-1 ">
              <div
                onClick={() => setViewChart("bar-chart")}
                className={`flex items-center justify-center rounded-[4px] h-8 w-8 cursor-pointer ${viewChart === "bar-chart" ? "bg-background" : ""}`}
              >
                <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-bar-chart-2"><line x1="18" y1="20" x2="18" y2="10"></line><line x1="12" y1="20" x2="12" y2="4"></line><line x1="6" y1="20" x2="6" y2="14"></line><line x1="2" y1="20" x2="2" y2="18"></line></svg>
              </div>
              <div
                onClick={() => setViewChart("area-chart")}
                className={`flex items-center justify-center rounded-[4px] h-8 w-8 cursor-pointer ${viewChart === "area-chart" ? "bg-background" : ""}`}
              >
                <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-area-chart"><path d="M3 18V6l7 7 4-4 7 7v2z"></path></svg>
              </div>
            </div>
          </div>
        </div>
      </CardHeader>
      {selectedTab === "All" && (
        <div className="flex flex-row items-center gap-6 px-6 pb-2">
          <div className="flex items-center gap-2">
            <span style={{ background: assetColors.Nifty, width: 14, height: 14, borderRadius: "50%", display: "inline-block" }}></span>
            <span className="text-sm">Nifty</span>
          </div>
          <div className="flex items-center gap-2">
            <span style={{ background: assetColors.Bank, width: 14, height: 14, borderRadius: "50%", display: "inline-block" }}></span>
            <span className="text-sm">Bank</span>
          </div>
          <div className="flex items-center gap-2">
            <span style={{ background: assetColors.Stock, width: 14, height: 14, borderRadius: "50%", display: "inline-block" }}></span>
            <span className="text-sm">Stock</span>
          </div>
        </div>
      )}
      <CardContent>
        {filteredData.length === 0 ? (
          <div className="text-center text-muted-foreground py-8">No data available for this selection.</div>
        ) : (
          <ChartContainer className="h-[450px] w-full" config={{}}>
            {selectedTab === "All" ? (
              viewChart === "bar-chart" ? (
                <BarChart data={filteredData} margin={{ left: 60, right: 12 }}>
                  <CartesianGrid vertical={false} />
                  <XAxis
                    dataKey={isWeekly ? "week_start" : "date"}
                    tickLine={false}
                    axisLine={false}
                    tickMargin={12}
                    tickFormatter={(value, idx) => {
                      if (!isWeekly) {
                        if (!value) return "";
                        const parts = typeof value === "string" ? value.split("-") : [];
                        if (parts.length !== 3) return value;
                        const [day, month, year] = parts;
                        const dateObj = new Date(`${year}-${month}-${day}`);
                        return dateObj.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "2-digit" });
                      } else {
                        const row = filteredData[idx];
                        return getWeeklyLabel(row);
                      }
                    }}
                    interval={Math.ceil(filteredData.length / 8)}
                  />
                  <YAxis
                    tickLine={false}
                    axisLine={false}
                    tickMargin={1}
                    tickCount={11}
                    domain={["dataMin-200000", "dataMax+100000"]}
                    tickFormatter={formatIndianNumber}
                  />
                  <ChartTooltip
                    cursor={false}
                    content={
                      <ChartTooltipContent
                        labelFormatter={(value, payload) => {
                          if (!isWeekly) {
                            if (!value) return "";
                            const parts = typeof value === "string" ? value.split("-") : [];
                            if (parts.length !== 3) return value;
                            const [day, month, year] = parts;
                            const formattedDate = `${year}-${month}-${day}`;
                            return new Date(formattedDate).toLocaleDateString("en-GB", {
                              day: "2-digit", month: "short", year: "2-digit"
                            });
                          } else {
                            if (payload && payload.length > 0) {
                              const row = payload[0].payload;
                              return getWeeklyLabel(row);
                            }
                            return value;
                          }
                        }}
                        formatter={(value, name) => [formatIndianNumber(value), name]}
                      />
                    }
                  />
                  <Bar dataKey="Stock" stackId="a" fill={assetColors.Stock} name="Stock" />
                  <Bar dataKey="Bank" stackId="a" fill={assetColors.Bank} name="Bank" />
                  <Bar dataKey="Nifty" stackId="a" fill={assetColors.Nifty} name="Nifty" />
                </BarChart>
              ) : (
                <LineChart data={filteredData} margin={{ left: 60, right: 12 }}>
                  <CartesianGrid vertical={false} />
                  <XAxis
                    dataKey={isWeekly ? "week_start" : "date"}
                    tickLine={false}
                    axisLine={false}
                    tickMargin={12}
                    tickFormatter={(value, idx) => {
                      if (!isWeekly) {
                        if (!value) return "";
                        const parts = typeof value === "string" ? value.split("-") : [];
                        if (parts.length !== 3) return value;
                        const [day, month, year] = parts;
                        const dateObj = new Date(`${year}-${month}-${day}`);
                        return dateObj.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "2-digit" });
                      } else {
                        const row = filteredData[idx];
                        return getWeeklyLabel(row);
                      }
                    }}
                    interval={Math.ceil(filteredData.length / 8)}
                  />
                  <YAxis
                    tickLine={false}
                    axisLine={false}
                    tickMargin={1}
                    tickCount={11}
                    domain={["dataMin-200000", "dataMax+100000"]}
                    tickFormatter={formatIndianNumber}
                  />
                  <ChartTooltip
                    cursor={false}
                    content={
                      <ChartTooltipContent
                        labelFormatter={(value, payload) => {
                          if (!isWeekly) {
                            if (!value) return "";
                            const parts = typeof value === "string" ? value.split("-") : [];
                            if (parts.length !== 3) return value;
                            const [day, month, year] = parts;
                            const formattedDate = `${year}-${month}-${day}`;
                            return new Date(formattedDate).toLocaleDateString("en-GB", {
                              day: "2-digit", month: "short", year: "2-digit"
                            });
                          } else {
                            if (payload && payload.length > 0) {
                              const row = payload[0].payload;
                              return getWeeklyLabel(row);
                            }
                            return value;
                          }
                        }}
                        formatter={(value, name) => [formatIndianNumber(value), name]}
                      />
                    }
                  />
                  <Line type="monotone" dataKey="Nifty" stroke={assetColors.Nifty} strokeWidth={3} dot={false} name="Nifty" connectNulls={true} />
                  <Line type="monotone" dataKey="Bank" stroke={assetColors.Bank} strokeWidth={3} dot={false} name="Bank" connectNulls={true} />
                  <Line type="monotone" dataKey="Stock" stroke={assetColors.Stock} strokeWidth={3} dot={false} name="Stock" connectNulls={true} />
                </LineChart>
              )
            ) : (
              <AreaChart data={filteredData} margin={{ left: 60, right: 12 }}>
                <CartesianGrid vertical={false} />
                <XAxis
                  dataKey={isWeekly ? "week_start" : "date"}
                  tickLine={false}
                  axisLine={false}
                  tickMargin={12}
                  tickFormatter={(value, idx) => {
                    if (!isWeekly) {
                      if (!value) return "";
                      const parts = typeof value === "string" ? value.split("-") : [];
                      if (parts.length !== 3) return value;
                      const [day, month, year] = parts;
                      const dateObj = new Date(`${year}-${month}-${day}`);
                      return dateObj.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "2-digit" });
                    } else {
                      const row = filteredData[idx];
                      return getWeeklyLabel(row);
                    }
                  }}
                  interval={Math.ceil(filteredData.length / 8)}
                />
                <YAxis
                  tickLine={false}
                  axisLine={false}
                  tickMargin={1}
                  tickCount={11}
                  domain={["dataMin-200000", "dataMax+100000"]}
                  tickFormatter={formatIndianNumber}
                />
                <ChartTooltip
                  cursor={false}
                  content={
                    <ChartTooltipContent
                      labelFormatter={(value, payload) => {
                        if (!isWeekly) {
                          if (!value) return "";
                          const parts = typeof value === "string" ? value.split("-") : [];
                          if (parts.length !== 3) return value;
                          const [day, month, year] = parts;
                          const formattedDate = `${year}-${month}-${day}`;
                          return new Date(formattedDate).toLocaleDateString("en-GB", {
                            day: "2-digit", month: "short", year: "2-digit"
                          });
                        } else {
                          if (payload && payload.length > 0) {
                            const row = payload[0].payload;
                            return getWeeklyLabel(row);
                          }
                          return value;
                        }
                      }}
                      formatter={(value, name) => [formatIndianNumber(value), name]}
                    />
                  }
                />
                <defs>
                  <linearGradient id="fillPnl" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="5%" stopColor={assetColors[selectedTab]} stopOpacity={0.8} />
                    <stop offset="95%" stopColor={assetColors[selectedTab]} stopOpacity={0.1} />
                  </linearGradient>
                </defs>
                <Area 
                  dataKey="pnl" 
                  type="natural" 
                  fill="url(#fillPnl)" 
                  fillOpacity={0.4} 
                  stroke={assetColors[selectedTab]} 
                  strokeWidth={3} 
                  dot={false} 
                  name={selectedTab}
                />
              </AreaChart>
            )}
          </ChartContainer>
        )}
      </CardContent>
    </Card>
  );
}



